/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

import { ActionTable } from '@bingads-webui-campaign-react/recommendation-visuals';

export class SamplePanel extends React.PureComponent {
  static propTypes = {
    insightTitle: PropTypes.string.isRequired,
    insight: PropTypes.string.isRequired,
    actionTitle: PropTypes.string,
    actions: PropTypes.oneOfType([
      PropTypes.shape({
        headers: PropTypes.array.isRequired,
        values: PropTypes.array.isRequired,
      }),
      PropTypes.string,
    ]),
    moreRecommendations: PropTypes.string,
    children: PropTypes.element.isRequired,
  };

  static defaultProps = {
    actionTitle: null,
    actions: null,
    moreRecommendations: null,
  };

  render() {
    let actionDetails;
    if (this.props.actions) {
      const { actionTitle, moreRecommendations } = this.props;
      const actions = this.props.actions.headers ?
        <ActionTable {...this.props.actions} /> :
        (
          <div className="sample-action-table">
            {this.props.actions}
          </div>
        );

      actionDetails = (
        <div>
          <div className="sample-horizontal-separator" />
          <div
            className="sample-action-title"
            dangerouslySetInnerHTML={{ __html: actionTitle }}
          />
          {actions}
          {moreRecommendations &&
            <div className="sample-more-recommendations">
              {moreRecommendations}
            </div>
          }
        </div>
      );
    }

    return (
      <div className="recommendation-sample">
        {this.props.insightTitle &&
          <div
            className="sample-insight-title"
            dangerouslySetInnerHTML={{ __html: this.props.insightTitle }}
          />
        }
        {this.props.insight &&
          <div
            className="sample-insight"
            dangerouslySetInnerHTML={{ __html: this.props.insight }}
          />
        }
        <div className="sample-visual">
          {this.props.children}
        </div>
        {actionDetails}
      </div>
    );
  }
}

